module.exports = __webpack_public_path__ + "static/media/mylocation.2a6077d8.gif";